import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  hide() {
    const splashScreen = document.getElementById('splashScreen');
    if (splashScreen) {
      splashScreen.remove();
    }
  }
}
